<template>
  <div class="section-navigator">
    <transition :name="['xs', 'sm'].includes($mq) ? 'fade' : null">
      <div v-show="sections.length">
        <v-tabs
          :class="[
            'section-tabs',
            $mq,
            { 'ml-n4': !['xs', 'sm'].includes($mq) },
            { 'is-below-first-section': isBelowFirstSection },
            isBelowFirstSection ? 'mb-0' : 'mb-3',
          ]"
          :value="visibleMenuSections[0]"
          show-arrows
          center-active
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            v-for="sectionName of sections"
            :key="sectionName"
            class="section-tab-name proxima-medium--font"
            @change="scrollToSection(sectionName)"
            >{{ sectionName }}</v-tab
          >
        </v-tabs>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import slugMe from '@/utils/slugMe'

export default {
  name: 'SectionNavigator',
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    scrollToSection(sectionName) {
      let setObservation = (state) => (this.isScrollObservationAllowed = state)
      this.$scrollTo('#' + slugMe(sectionName), 700, {
        offset: -105,
        onStart: () => setObservation(false),
        onDone: () => setObservation(true),
        onCancel: () => setObservation(true),
      })
    },
  },
  computed: {
    ...mapFields('cart', ['visibleMenuSections', 'isScrollObservationAllowed']),
    isBelowFirstSection() {
      return (
        !this.visibleMenuSections.includes(0) ||
        this.visibleMenuSections.length > 1
      )
    }, // isBelowFirstSection
  },
}
</script>

<style lang="scss">
.section-navigator {
  position: sticky;
  top: 48px;
  background: white;
  z-index: 4;
}
.section-tabs {
  width: calc(100% + 30px);
  position: sticky;
  top: 48px;
  background: white;
  z-index: 4;
  transition: margin 0.3s ease;
  &.is-below-first-section {
    border-bottom: 1px solid #ddd;
  }
  &.xs,
  &.sm {
    position: fixed;
    top: 48px;
    width: 100%;
    left: 0;
    margin-left: 0;
  }
}
.v-tab.section-tab-name {
  font-size: 0.65rem;
}
</style>
